<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3041_14862)">
<rect x="2.35" y="1.85" width="18.3" height="18.3" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
<path d="M8.68947 8.76157C8.69592 7.9873 8.69915 7.60016 8.95159 7.45817C9.20403 7.31617 9.53655 7.51445 10.2016 7.91101L13.9343 10.1368C14.5798 10.5218 14.9026 10.7142 14.902 10.9989C14.9014 11.2836 14.5778 11.4747 13.9306 11.8568L10.1607 14.0826C9.48557 14.4813 9.14799 14.6806 8.89527 14.5349C8.64254 14.3893 8.64581 13.9972 8.65235 13.2132L8.68947 8.76157Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3041_14862">
<rect width="22" height="22" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
